var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center mt-5 ml-2 mr-2"},[_c('b-alert',{attrs:{"variant":"success","show":""}},[_c('b',[_vm._v("Félicitations !")]),_vm._v(" La procédure de signature est désormais terminée.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }